<template>
  <v-card
    height="185"
    width="255"
    @click="onClick(item)"
    class="rounded-lg"
  >
    <v-img
      class="align-end text-white"
      height="120"
      :src="item.image !== null ? item.image : genericImage"
      cover
    />
    <div
      class="d-flex flex-row align-center px-2"
      style="height: 65px;"
    >
      <span 
        class="pa-2 d-inline-block flex-shrink-0"
        style="width: 48px; height: 48px;"
        v-if="item.domain"
      >
        <v-img :src="getLogo(item.domain).src" />
      </span>
      <v-card-title>
        {{ item.title }}
      </v-card-title>
    </div>
  </v-card>
</template>

<script>

import { mapGetters } from "vuex";

export default {
  name: 'CarouselCard',
  computed: {
    ...mapGetters(['schoolsLogo']),
  },
  props: {
    item: {
      type: Object,
      default: function() {
        return {}
      }
    },
    image: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    domain: {
      type: String,
      default: ''
    },
    onClick: {
      type: Function,
      default: function() {
        return false
      }
    },
    genericImage: {
      type: String,
      default: '/img/generic-news.svg'
    },
  },
  methods: {
    getLogo(schoolId) {
      let logo = { src: "/NSWGov_Logo.png"}
      if(schoolId != null) {
        const result = this.schoolsLogo.find(logo => logo.schoolId == schoolId);
        if(result) {
          logo.src = result.logo
        }
      }
      return logo;
    },
  }
}
</script>
<style lang="scss" scoped>
  .v-card__title {
    word-break: break-word;
    font-size: 1rem;
    line-height: 1.1rem;
    padding: 2px 8px;
    flex-grow: 1;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .v-slide-group::v-deep .v-slide-group__content {
    padding-left: 16px;
    padding-right: 16px;
  }
</style>